
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solar-academy",
      function () {
        return require("private-next-pages/solar-academy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solar-academy"])
      });
    }
  